import { CardBrandEnum, CardProduct } from '@zeusm/business/core/entities';

export const mockCardProducts: CardProduct[] = [
  {
    id: '1',
    binCode: 'binCode',
    binType: 'binType',
    cardBrand: 'VISA' as CardBrandEnum,
    cardGeo: 'cardGeo',
    hasCrossBorderFee: true,
    currency: 'USD',
    integrationId: 'integration-1',
    declineFee: '0',
    depositFee: '0',
    monthlyFee: '0',
    name: 'name',
    transactionFee: '0',
    defaultSkinId: '',
    iconMeta: false,
    iconNonMeta: false,
    icon3DSecure: false,
    iconNoMccLimit: false,
    hide3dsPhone: false,
  },
];
